(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gp-elegant-footer"] && !Shopify.designMode) return;
  try {
    function setupGPFooter(root){root.querySelectorAll('.gp-footer-columns').forEach(columns=>{if(columns.dataset.ready)return;columns.dataset.ready='true';const media=window.matchMedia('(min-width:768px)');const groups=columns.querySelectorAll('details');const sync=()=>groups.forEach(group=>group.open=media.matches);sync();media.addEventListener('change',sync);});}
setupGPFooter(document);
document.addEventListener('shopify:section:load',event=>setupGPFooter(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gp-floating-dock"] && !Shopify.designMode) return;
  try {
    function gpSetupDock(){
const gift=document.querySelector('.gp-floating-gift');if(!gift||gift.dataset.ready)return;gift.dataset.ready='true';
const findTrigger=()=>document.querySelector('[class*="kl-teaser-"] [role="button"]');
const sync=()=>{gift.hidden=!findTrigger();};
gift.addEventListener('click',()=>{const trigger=findTrigger();if(trigger)trigger.click();});
sync();new MutationObserver(sync).observe(document.body,{childList:true,subtree:true});
}
gpSetupDock();
document.addEventListener('shopify:section:load',gpSetupDock);
  } catch(e) { console.error(e); }
})();

})();
